import { featuredStories } from "@/mocks/chiguaData";
import SectionHeading from "./SectionHeading";
import TagBadge from "./TagBadge";

export default function HotPicks() {
  const lead = featuredStories[0];
  const side = featuredStories.slice(1);

  return (
    <section id="hot" className="bg-background-50 py-14 md:py-20">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <SectionHeading
          kicker="本周炸裂现场"
          title="神转折头条"
          desc="悬念开场、结局打脸的当红反转瓜，进反转现场可一键揭晓完整结尾。"
        />

        <div className="mt-10 grid gap-6 lg:grid-cols-5">
          <a
            href="#library"
            className="group relative block overflow-hidden rounded-3xl lg:col-span-3"
          >
            <div className="relative h-72 w-full overflow-hidden md:h-[440px]">
              <img
                src={lead.img}
                alt={`吃瓜反差神转折故事：${lead.title}`}
                className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/20 to-transparent"></div>
              <div className="absolute inset-x-0 bottom-0 p-5 md:p-7">
                <div className="flex items-center gap-2">
                  <TagBadge tag={lead.tag} />
                  <span className="text-xs text-background-100/80">{lead.category}</span>
                </div>
                <h3 className="mt-3 font-heading text-xl font-bold leading-snug text-background-50 md:text-3xl">
                  {lead.title}
                </h3>
                <p className="mt-2 line-clamp-2 text-sm text-background-100/85 md:text-base">{lead.hook}</p>
                <span className="mt-4 inline-flex items-center gap-1.5 rounded-full bg-accent-500 px-4 py-2 text-xs font-semibold text-background-50 transition-colors group-hover:bg-accent-600 md:text-sm">
                  揭晓结局
                  <i className="ri-arrow-right-line" aria-hidden="true"></i>
                </span>
              </div>
            </div>
          </a>

          <div className="flex flex-col gap-4 lg:col-span-2">
            {side.map((s) => (
              <a
                key={s.id}
                href="#library"
                className="group flex flex-1 flex-col gap-4 overflow-hidden rounded-2xl bg-background-100/70 p-3 transition-colors hover:bg-background-200/60 sm:flex-row"
              >
                <div className="relative h-40 w-full overflow-hidden rounded-xl sm:h-auto sm:w-36">
                  <img
                    src={s.img}
                    alt={`吃瓜反差结局意外故事：${s.title}`}
                    className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                  />
                </div>
                <div className="flex flex-1 flex-col justify-center gap-2 py-1">
                  <TagBadge tag={s.tag} />
                  <h3 className="font-heading text-base font-bold leading-snug text-foreground-950 group-hover:text-primary-700">
                    {s.title}
                  </h3>
                  <p className="text-xs text-foreground-500">{s.category} · {s.author}</p>
                </div>
              </a>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}